/***************************************************************
12/07/2018
Alexander Self
Mech harvest table
- Table summary of mech harvest
***************************************************************/
import { sumProp, avgProp, handleBalance } from '../../harvest_utils';
import React from 'react';
import moment from 'moment';

const MechHarvestTable = ({ 
  harvest, 
  totals, 
  field, 
  onClick 
}) => {
  if (!harvest) return <span></span>;
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr className="harvest-headers">
          <th id={'h-date'} onClick={(e) => onClick(e.target.id)}>Date</th>
          <th id={'h-round'} onClick={(e) => onClick(e.target.id)}>Round</th>
          <th id={'h-field'} onClick={(e) => onClick(e.target.id)}>Field</th>
          <th id={'h-block'} onClick={(e) => onClick(e.target.id)}>Block</th>
          <th id={'h-status'} onClick={(e) => onClick(e.target.id)}>Status</th>
          <th id={'h-hours'} onClick={(e) => onClick(e.target.id)}>Hours</th>
          <th id={'h-treesCovered'} onClick={(e) => onClick(e.target.id)}>Trees</th>
          <th id={'h-acresCompleted'} onClick={(e) => onClick(e.target.id)}>Acres Complete</th>
          <th id={'h-acresBalance'} onClick={(e) => onClick(e.target.id)}>Acres Balance</th>
          <th id={'h-percentComplete'} onClick={(e) => onClick(e.target.id)}>% Complete</th>
          <th id={'h-containerCount'} onClick={(e) => onClick(e.target.id)}>Container #</th>
          <th id={'h-estimatedLbs'} onClick={(e) => onClick(e.target.id)}>Est. lbs</th>
          <th id={'h-density'} onClick={(e) => onClick(e.target.id)}>Density</th>
          <th id={'h-acresPerHour'} onClick={(e) => onClick(e.target.id)}>Acres/Hr</th>
        </tr>
      </thead>
      <tbody>
        {
          harvest.map((h) => {
            return (
              <tr key={h.id ? h.id : h.guid ? h.guid : Math.random()}>
                <td>{ moment(h.date).format('YYYY-MM-DD') }</td>
                <td>{ h.round }</td>
                <td>{ h.field }</td>
                <td>{ h.block }</td>
                <td>
                   { h.status === 0 || h.status === '0' ? <span className="label label-incomplete">Incomplete</span>
                      : <span className="label label-complete">Complete</span>
                   }
                </td>
                <td>{ h.hours }</td>
                <td>{ h.treesCovered }</td>
                <td>{ h.acresCompleted }</td>
                <td>{ h.acresBalance }</td>
                <td>{ (h.percentComplete*100).toFixed(2) }%</td>
                <td>{ h.containerCount }</td>
                <td>{ h.estimatedLbs }</td>
                <td>{ h.density } lbs/tree</td>
                <td>{ h.acresPerHour }</td>
              </tr>
            )
          })
        }
      </tbody>
      { totals ?
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><center><b>{ sumProp('hours', harvest) }</b></center></td>
            <td><center><b>{ sumProp('treesCovered', harvest) }</b></center></td>
            <td><center><b>{ sumProp('acresCompleted', harvest) }</b></center></td>
            <td>
              <center>
                <b>{ handleBalance(harvest, field) < 0 ?
                  <span className="day-off">{ handleBalance(harvest, field) }</span>
                : <span>{ handleBalance(harvest, field) }</span> }</b>
              </center>
            </td>
            <td><center><b>{ (sumProp('percentComplete', harvest)*100).toFixed(2) }%</b></center></td>
            <td><center><b>{ sumProp('containerCount', harvest) }</b></center></td>
            <td><center><b>{ sumProp('estimatedLbs', harvest) }</b></center></td>
            <td><center><b>{ avgProp('density', harvest) } lbs/tree</b></center></td>
            <td><center><b>{ avgProp('acresPerHour', harvest) }</b></center></td>
          </tr>
        </tfoot>
        : <tfoot></tfoot>
      }

    </table>
  );
};

export default MechHarvestTable;



// WEBPACK FOOTER //
// ./src/components/harvest/mechHarvest_table.jsx